import gql from 'graphql-tag';

import dokkioUsersPageFragment from '../fragments/dokkioUsersPageFragment';

export const queryDokkioUsersPage = gql`
  query dokkioUsersPage(
    $name: String
    $email: String
    $query: String
    $isPending: Boolean
    $isDeleted: Boolean
    $count: Int
    $offset: Int
  ) {
    dokkioUsersPage(
      name: $name
      email: $email
      query: $query
      isPending: $isPending
      isDeleted: $isDeleted
      count: $count
      offset: $offset
    ) {
      ...dokkioUsersPageFragment
    }
  }
  ${dokkioUsersPageFragment}
`;
export default queryDokkioUsersPage;
